import { routes } from 'features/verify/routes';
import { OnboardLayout } from 'features/verify/ui/onboard-layout';

import { navigate } from 'libs/router';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { ErrorType, mapErrorName, setError } from 'model/error.model';
import { captureErrorFx } from 'model/helpers/analytics.model';
import { sendEvent } from 'model/helpers/events.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { Fragment, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import { Button } from 'ui/atoms/button';
import { InfoIcon } from 'ui/icons/info-icon';
import { version } from '../../../../package.json';

const mediaDevices = navigator.mediaDevices;
const getUserMedia = mediaDevices && mediaDevices.getUserMedia ? mediaDevices.getUserMedia.bind(mediaDevices) : null;

export const AccessRequest = () => {
	const t = useLocalization();
	const [start] = useState(Date.now());

	useEffect(() => {
		screenHistoryPush(ScreenName.camera_permissions_requested);
		setTimeout(() => {
			sendEvent({ event: 'camera_permissions_screen_shown' });
		}, 20);
	}, []);

	const promptPermissions = async () => {
		sendEvent({ event: 'camera_allow_clicked' });
		try {
			await getUserMedia({
				video: {
					width: { min: 480 },
					height: { min: 640 },
				},
				audio: false,
			});
			navigate(routes.document);
			sendEvent({
				event: 'camera_permissions_granted',
				event_attributes: {
					duration: Date.now() - start,
				},
			});
		} catch (e) {
			const errorType = mapErrorName(e.name);

			captureErrorFx(new Error(e.message));
			setError(errorType);
			sendEvent({
				event: 'camera_permissions_rejected',
				event_attributes: {
					screen: 'grant_access',
					error_type: e.name,
					duration: Date.now() - start,
				},
			});
		}
	};

	return (
		<OnboardLayout
			title={t('mobile.camera.title')}
			subtitle={t('mobile.camera.subtitle')}
			info={[{
				icon: <InfoIcon fill={'var(--text-tertiary)'}/>,
				text: <Fragment>
					{t('mobile.camera.hint')}
				</Fragment>,
			}]}
		>
			<ImageContainer>
				<img src={`https://cdn.hive.id/verify-js/${version}/images/camera.svg`} alt=""/>
			</ImageContainer>
			<Button
				onClick={() => {
					setError(ErrorType.camera_access_declined);
					sendEvent({ event: 'camera_deny_clicked' });
				}}
				className={btn}
				type={'default'}
				name={'mobile.camera.btn.decline'}
			>
				{t('mobile.camera.btn.decline')}
			</Button>
			<Button
				onClick={promptPermissions}
				name={'mobile.camera.btn'}
			>
				{t('mobile.camera.btn')}
			</Button>
		</OnboardLayout>
	);
};

const btn = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  width: 100%;
`;
const ImageContainer = styled('div')`
  margin: auto;
	
	@media (max-height: 500px) {
		display: none;
	}
`;
